/**
 * 可协作时段选项（画像、候选人解析、匹配需求共用同一份词表，避免三处不一致）。
 * 这些是**界面标签**：后端 TeamRequest.slots / CandidateProfile.slots 就是字符串数组，
 * 因此自定义时段（用户手填）也能正常保存与参与匹配。
 * v0.2 T75：由 apps/web 上移至 shared，前端一句话解析与后端 LLM 抽取回退共用。
 */
export const SLOT_OPTIONS = [
  '周一晚',
  '周二晚',
  '周三晚',
  '周四晚',
  '周五晚',
  '周六白天',
  '周六晚',
  '周日白天',
  '周日晚',
  '工作日晚间',
  '周末全天',
  '线上随时',
] as const;

export type SlotOption = (typeof SLOT_OPTIONS)[number];

export function isSlotOption(value: string): value is SlotOption {
  return (SLOT_OPTIONS as readonly string[]).includes(value);
}

/** 从自由文本里识别已收录的时段标签（用于一句话录入） */
export function detectSlots(text: string): string[] {
  return SLOT_OPTIONS.filter((slot) => text.includes(slot));
}
